import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useHistory } from 'react-router-dom';

const PagamentoSucessoPage = () => {
  const history = useHistory();
  return (
    <Container maxWidth="sm" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box textAlign="center" width="100%">
        <Typography variant="h3" gutterBottom color="success.main">
          Pagamento realizado com sucesso!
        </Typography>
        <Typography variant="h6" gutterBottom>
          Seu pagamento foi confirmado. Obrigado por comprar conosco!
        </Typography>
        <Button variant="contained" color="primary" onClick={() => history.push('/')}
          style={{ marginTop: 32 }}>
          Voltar para a Home
        </Button>
      </Box>
    </Container>
  );
};

export default PagamentoSucessoPage; 